exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-height[data-v-bf36eecc] {\n  height: calc(100vh - 13rem);\n}\n.style-border[data-v-bf36eecc] {\n  border-width: thin !important;\n  border-style: solid !important;\n  border-color: rgb(229, 231, 235) !important;\n}\n", ""]);

// exports
